import Vue from 'vue'
import EStorage from '@beetronix/estorage';

Vue.use(EStorage);
export default new EStorage({})